/** Auth0 SMS passwordless connection (primary tenant login). */
export const AUTH0_SMS_CONNECTION =
  import.meta.env.VITE_AUTH0_SMS_CONNECTION?.trim() || 'sms';

/** Auth0 email passwordless connection (international backup login). */
export const AUTH0_EMAIL_CONNECTION =
  import.meta.env.VITE_AUTH0_EMAIL_CONNECTION?.trim() || 'email';
